import React, { createRef } from "react";
import CreateProcedureDetail from "./createProcedureDetail";
import NormalModal from "../../../base/basicComponents/modal";
import "./style/index.scss";
import RoutingComponent from "../../../base/common/RoutingComponent";
import ProcedureDetailService from "../../../service/procedureFile/ProcedureDetailService";
import { message } from "antd";
import store from "../../../store";
import {
  setModifiedTime,
  setExecutePendingAction,
  setPendingAction,
  setProcedureId,
  getPendingAction,
  isExecutePendingAction,
} from "../../../store/actions/procedureDetailPageActions";
import { PendingActionTypes } from "../../../store/actions/constants";
import { debounce } from "lodash";
import { openSections } from "../../../app/publicDictionaryValues";
const procedureFilesRef = createRef();
const supportingFilesRef = createRef();
const procedureInformationRef = createRef();
const shareTaskRef = createRef();

export default class ProcedureDetail extends RoutingComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      isModalOpen: false,
      procedureId: "",
    };
    // @ts-ignore
    this.procedureTaskId = this._getRoutingParam("ProcedureTaskId");
    // @ts-ignore
    this.openSection = this._getRoutingParam("OpenSection");
    // @ts-ignore
    this.unsubscribe = null;
    // @ts-ignore
    this.lastPendingAction = null;
  }

  componentDidMount() {
    store.dispatch(setExecutePendingAction(false));
    store.dispatch(setPendingAction(null));
    // @ts-ignore
    if (this.openSection === openSections.procedureFile) {
      this.props.history.replace(
        window.location.pathname.replace(openSections.procedureFile, openSections.default)
      );
      this.setState({ ...this.state }, () => {
        // @ts-ignore
        this.openSection = this._getRoutingParam("OpenSection");
      });

      store.dispatch(setPendingAction(PendingActionTypes.ProcedureFilesEdit));
      // @ts-ignore
      this.lastPendingAction = PendingActionTypes.ProcedureFilesEdit;
    }
    this.getProcedureId();
    // @ts-ignore
    this.unsubscribe = store.subscribe(debounce(this.handleStoreChange, 300));
  }

  componentWillUnmount() {
    // @ts-ignore
    if (this.unsubscribe) {
      // @ts-ignore
      this.unsubscribe();
      store.dispatch(setExecutePendingAction(false));
      store.dispatch(setPendingAction(null));
    }
  }

  handleStoreChange = async () => {
    const pendingAction = getPendingAction();
    const isExecute = isExecutePendingAction();

    if (pendingAction && !isExecute) {
      store.dispatch(setExecutePendingAction(true));
    }

    // @ts-ignore
    if (pendingAction !== this.lastPendingAction) {
      if (pendingAction) {
        this.props.history.replace(window.location.pathname);
        this.setState({ procedureId: "" }, () => {
          // @ts-ignore
          this.openSection = this._getRoutingParam("OpenSection");
          this.getProcedureId();
        });
      }
      // @ts-ignore
      this.lastPendingAction = pendingAction;
    }
  };

  getProcedureId = () => {
    ProcedureDetailService.getProcedureInfoByProcedureTaskId(
      // @ts-ignore
      { procedureTaskId: this.procedureTaskId },
      (result: any) => {
        if (!result.procedureID) {
          // @ts-ignore
          window.location = "/NoPermissionPage/noAccess";
          return;
        }
        store.dispatch(setModifiedTime(result.modifiedTime));
        store.dispatch(setProcedureId(result.procedureID));
        this.setState({ procedureId: result.procedureID });
      },
      (error: any) => {
        message.error("Failed To Get Procedure Data!", 3);
      }
    );
  };

  render() {
    const { isModalOpen, procedureId } = this.state;
    return (
      <div className="procedureDetailPage">
        {!!procedureId && (
          // @ts-ignore
          <CreateProcedureDetail
            isShowUploadBtn={false}
            isShowDeleteBtn={false}
            isShowDownloadBtn={true}
            isShowShareBtn={true}
            isShowActionBtns={false}
            procedureFilesRef={procedureFilesRef}
            supportingFilesRef={supportingFilesRef}
            procedureInformationRef={procedureInformationRef}
            shareTaskRef={shareTaskRef}
            title="Procedure Detail Page"
            procedureId={procedureId}
            procedureTaskId={(this as any).procedureTaskId}
            openSection={(this as any).openSection}
            pageType="procedureDetail"
          />
        )}
        <NormalModal
          testid="procedure-detail-modal"
          open={isModalOpen}
          closable={true}
          okText=""
          cancelText=""
        />
      </div>
    );
  }
}
